import React from "react";
import { CheckCircle2 } from "lucide-react";
import { whyFeatures } from "../mock";

const nursePortrait =
  "https://images.unsplash.com/photo-1691177418473-8df169e0cbc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxudXJzZSUyMHBvcnRyYWl0JTIwc2NydWJzfGVufDB8fHx8MTc4OTg0ODk2OXww&ixlib=rb-4.1.0&q=85&w=800";

const FeatureItem = ({ f, align, highlight }) => (
  <div className={`flex items-start gap-4 ${align === "right" ? "flex-row-reverse text-right" : ""}`}>
    <div
      className="why-dot shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white"
      style={{ background: highlight ? "#3aa84f" : "var(--orange)" }}
    >
      <CheckCircle2 size={26} />
    </div>
    <div>
      <h4 className="font-display font-bold text-[#0e2a63] text-lg">{f.title}</h4>
      <p className="text-slate-500 text-[14px] leading-snug mt-1">{f.desc}</p>
    </div>
  </div>
);

const WhyChooseUs = () => {
  const left = whyFeatures.slice(0, 4);
  const right = whyFeatures.slice(4, 8);

  return (
    <section className="py-24 bg-[#f3f7fc] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="reveal">
          <span className="eyebrow text-[#e07c24]">Why Choose Us?</span>
          <h2 className="font-display font-bold text-[#0e2a63] text-[34px] sm:text-[46px] mt-4">
            Offering Professional Nursing Care.
          </h2>
        </div>

        <div className="mt-16 grid lg:grid-cols-[1fr_auto_1fr] gap-10 lg:gap-8 items-center">
          <div className="reveal flex flex-col gap-10 order-2 lg:order-1">
            {left.map((f, i) => (
              <FeatureItem key={f.title} f={f} align="right" highlight={i === 0} />
            ))}
          </div>

          <div className="reveal reveal-delay-1 order-1 lg:order-2 flex justify-center">
            <div className="relative">
              <div
                className="absolute inset-0 rounded-full scale-110 blur-2xl opacity-30"
                style={{ background: "radial-gradient(circle, #14357e 0%, transparent 70%)" }}
              />
              <div className="relative w-[280px] h-[380px] sm:w-[320px] sm:h-[440px] rounded-[40%_40%_46%_46%/8%_8%_50%_50%] overflow-hidden shadow-2xl border-4 border-white">
                <img src={nursePortrait} alt="Professional nurse" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>

          <div className="reveal reveal-delay-2 flex flex-col gap-10 order-3">
            {right.map((f) => (
              <FeatureItem key={f.title} f={f} align="left" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
